// Arte do kit v0.2 (SVGs usados como imagem, sem redesenho).
import logoMark from './assets/svg/logo-mark.svg';
import logoMarkLight from './assets/svg/logo-mark-light.svg';
import mapBase from './assets/svg/map-base.svg';
import crestBk from './assets/svg/crest-bk.svg';
import crestLah from './assets/svg/crest-lah.svg';
import crestMerc from './assets/svg/crest-merc.svg';
import crestRose from './assets/svg/crest-rose.svg';
import crestToro from './assets/svg/crest-toro.svg';
import crestUnit from './assets/svg/crest-unit.svg';
import sigilFerumbras from './assets/svg/sigil-ferumbras.svg';
import sigilGazharagoth from './assets/svg/sigil-gazharagoth.svg';
import sigilGhazbaran from './assets/svg/sigil-ghazbaran.svg';
import sigilMorgaroth from './assets/svg/sigil-morgaroth.svg';
import sigilOrshabaal from './assets/svg/sigil-orshabaal.svg';
import sigilZushuka from './assets/svg/sigil-zushuka.svg';
import vocDruid from './assets/svg/vocation-druid.svg';
import vocKnight from './assets/svg/vocation-knight.svg';
import vocPaladin from './assets/svg/vocation-paladin.svg';
import vocSorcerer from './assets/svg/vocation-sorcerer.svg';
import vocMonk from './assets/svg/vocation-monk.svg';
import iconDepot from './assets/svg/icon-depot.svg';
import iconHeart from './assets/svg/icon-heart.svg';
import iconHorns from './assets/svg/icon-horns.svg';
import iconShield from './assets/svg/icon-shield.svg';
import iconShip from './assets/svg/icon-ship.svg';
import iconSkull from './assets/svg/icon-skull.svg';
import iconStaff from './assets/svg/icon-staff.svg';
import iconSword from './assets/svg/icon-sword.svg';
import iconTemple from './assets/svg/icon-temple.svg';
import iconWild from './assets/svg/icon-wild.svg';
import { theme } from './theme';

export const art = { logoMark, logoMarkLight, mapBase };

const CRESTS: Record<string, string> = {
  bk: crestBk,
  lah: crestLah,
  merc: crestMerc,
  rose: crestRose,
  toro: crestToro,
  unit: crestUnit,
};

/** Brasão pela cor da guilda (id do motor). */
export function crestOf(color: string): string {
  const g = theme.guilds.find((x) => x.color === color);
  return CRESTS[g?.id ?? ''] ?? crestRose;
}

const SIGILS: Record<string, string> = {
  ferumbras: sigilFerumbras,
  gazharagoth: sigilGazharagoth,
  ghazbaran: sigilGhazbaran,
  morgaroth: sigilMorgaroth,
  orshabaal: sigilOrshabaal,
  zushuka: sigilZushuka,
};
export const sigilOf = (boss: string) => SIGILS[boss] ?? sigilFerumbras;

const PORTRAITS: Record<string, string> = {
  defense: vocKnight,
  range: vocPaladin,
  damage: vocSorcerer,
  heal: vocDruid,
  harmony: vocMonk,
};
export const portraitOf = (vocation: string | null) => PORTRAITS[vocation ?? ''] ?? vocKnight;

export const icons = {
  depot: iconDepot,
  heart: iconHeart,
  horns: iconHorns,
  shield: iconShield,
  ship: iconShip,
  skull: iconSkull,
  staff: iconStaff,
  sword: iconSword,
  temple: iconTemple,
  wild: iconWild,
};

/** Ícone do símbolo de uma carta de território (espada, escudo, cajado ou curinga). */
export const symbolIcon = (symbol: string) => icons[symbol as keyof typeof icons] ?? icons.wild;
